import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchJobCategoryList } from "./JobCategoryAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchJobCategoryListAsync = createAsyncThunk(
  "JobList/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchJobCategoryList();

      // adjust according to actual API response shape
      const resp = data?.response ?? data;
      if (!resp) {
        throw new Error("Invalid response structure");
      }
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const JobCategoryListSlice = createSlice({
  name: "jobCategoryList", // make it consistent with selector
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobCategoryListAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchJobCategoryListAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchJobCategoryListAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const selectJobCategoryList = (state) => state.jobCategoryList.data;

export default JobCategoryListSlice.reducer;
